module.exports = __webpack_public_path__ + "img/wenli-3.bf3dd553.png";